<template>
  <div>
    <el-dialog title="点评" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form size="small" :model="form" :rules="formRules" ref="form">
        <!--分类名称-->
        <!-- <el-form-item label="问题" prop="name" :label-width="formLabelWidth">
          <el-input v-model="form.question" autocomplete="off" placeholder="请输入问题"></el-input>
        </el-form-item> -->

        <el-form-item label="选择用户" prop="user_id" :label-width="formLabelWidth">
          <el-row>
            <el-button type="primary" icon="el-icon-plus" @click="openUserDialog">选择1位用户</el-button>
            <div v-if="form.user_id" class="img">
              <img :src="user.avatarUrl" width="100" height="100" />
            </div>
          </el-row>
        </el-form-item>
        
        <el-form-item label="点评" prop="content" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.content" :rows="5" placeholder="请输入点评内容"></el-input>
        </el-form-item>

        <!--是否显示-->
        <el-form-item label="是否置顶" prop="is_top" :label-width="formLabelWidth">
          <el-radio-group v-model="form.is_top">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <p class="gray9">注：设置置顶会增加点评积分</p>
        </el-form-item>

        <!-- <el-form-item label="评价图片" prop="imgs" :label-width="formLabelWidth">
          <el-row>
            <el-tooltip effect="dark" content="建议尺寸750x750" placement="top">
              <el-button type="primary" icon="el-icon-plus" @click="openUpload">选择评价图片</el-button>
            </el-tooltip>
            <div v-if="form.imgs" class="img d-s-s">
              <img :src="item.file_path" width="100" height="100" v-for="(item,index) in form.imgs" :key="index" />
            </div>
          </el-row>
        </el-form-item> -->
        
      </el-form>
      <!--操作按钮-->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
      </div>
      
    </el-dialog>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    <!--用户选择-->
    <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>
import DakaApi from '@/api/study/daka.js';
import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
export default {
  components: {
    Upload,
    GetUser
  },
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      form: {
        user_id: 0,
        content: '',
        is_top: 0,
        // imgs: [],
      },
      /*验证规则*/
      formRules: {
        content: [{ required: true, message: '请输入点评内容', trigger: 'blur' }],
        user_id: [{ required: true, message: '请选择用户', trigger: 'blur' }],
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      open_user: false,
      isupload: false,
    };
  },
  props: {
    open_comment:Boolean,
    selectModel:Object,
  },
  created() {
    this.dialogVisible = this.open_comment;
  },
  methods: {
    /*选择分类*/
    handleChange(e) {
    },

    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          params.record_id = self.selectModel.daka_id;
          DakaApi.addComment(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    },

    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      this.form.imgs = e;
      this.isupload = false;
    },

    /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },

    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        this.form.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    },
   
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/daka/part/Comment.vue